import * as React from 'react';
import {Route, RouteProps} from 'react-router';
import AppNotificationsContainer from '../../containers/AppNotificationsContainers';
import Layout from '../Layout';
import Sider from './Sider';
import MainContainer from './MainContainer';

interface AuthLayoutProps extends RouteProps {}

export default class AuthLayout extends React.Component<AuthLayoutProps, {}> {
  public render() {
    const {children, ...restProps} = this.props;

    return (
      <Route
        render={matchProps => (
          <Layout hasSider={true}>
            <AppNotificationsContainer />
            <Sider />
            <MainContainer>{React.cloneElement(React.Children.only(children), matchProps)}</MainContainer>
          </Layout>
        )}
        {...restProps}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AuthLayout/AuthLayout.tsx